import React from "react";
import Translator from "Languages/Utility/Translator";
import * as Icons from 'react-bootstrap-icons';

export default function IncreaseGroupFormatter(cell, admin_interface = true) {
  return (
    <div className={admin_interface &&`saiu_${cell}`}>
      {admin_interface &&
        {
          Product: <Icons.Person size={15}/> ,
          Limit: <Icons.BoxFill size={15}/> ,
          SuperVisor: <Icons.PersonBoundingBox size={15}/> ,
          Factor: <Icons.Receipt size={15}/> ,
        }[cell]
      }
      {" "}
      {
        cell 
          ? <Translator id={`saiu_${cell}`} noSpan />
          : <Translator id='undefined' />
      }
     </div>
  );
}